import React from 'react'
import { Trans, useTranslation } from 'next-i18next'
import {
  Bleed,
  Column,
  Columns,
  Inline,
  Stack,
  Text,
  TextLinkButton
} from '@machobear/design-system'

import { FieldInput } from '@/components/form'

const ApplyFlowStepOne = ({
  handleOpenAuthModal
}: {
  handleOpenAuthModal: () => void
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Bleed top={'xxlarge'}>
        <Stack space="xlarge">
          <Stack space="medium">
            <Text size="small" weight="strong" tone="secondary">
              {t('r.auth.create.step_one.label', 'Step 1 of 3')}
            </Text>

            <Text size="xlarge" weight="strong">
              {t(
                'r.auth.create.first_and_last_name.text',
                "First off, let's tell the landlord your name."
              )}
            </Text>
            <Inline space="xxxsmall" alignY="center">
              <Text size="small">
                {t(
                  'b.auth.create.already_have_an_account_alt.text',
                  'Already have an account?'
                )}{' '}
              </Text>

              <Trans
                t={t}
                i18nKey="b.auth.create.already_have_an_account_login_alt.text"
              >
                <Inline alignY="center" space="none">
                  <Text tone="link" size="small">
                    <TextLinkButton
                      onClick={handleOpenAuthModal}
                      id="web-auth-switch-to-login"
                    >
                      Log in here
                    </TextLinkButton>
                  </Text>
                  <Text>.</Text>
                </Inline>
              </Trans>
            </Inline>
          </Stack>
          <Columns space="small" collapseBelow="tablet">
            <Column width="1/2">
              <FieldInput
                name="first_name"
                autoComplete="section-register-renter given-name"
                required
                placeholder={t('common.first_name', 'First name')}
              />
            </Column>
            <Column>
              <FieldInput
                name="last_name"
                autoComplete="section-register-renter family-name"
                required
                placeholder={t('common.last_name', 'Last Name')}
              />
            </Column>
          </Columns>
        </Stack>
      </Bleed>
    </>
  )
}

export default ApplyFlowStepOne
